import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import GlobalFilterComponent from '../../../../components/GlobalFilterComponent';
const columns = [
  { field: 'name', Text: 'name' },
  { field: 'description', Text: 'description' },
  { field: 'alias', Text: 'alias' },
];
const OperationFilterTabs = () => {
  const begin = (args: any) => {
    if (args.isSwiped) {
      args.cancel = true;
    }
  };
  return (
    <div className='main-content-operation'>
      <TabComponent
        enablePersistence={true}
        selecting={begin.bind(this)}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          <TabItemDirective
            header={{ text: 'Responsibility' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'operation$responsibility'}
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: 'Status' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'operation$status'}
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: 'Type' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'operation$type'}
                />
              </>
            )}
          />
          <TabItemDirective
            header={{ text: 'Priority' }}
            content={() => (
              <>
                <GlobalFilterComponent
                  columns={columns}
                  query={'operation$priority'}
                />
              </>
            )}
          />
        </TabItemsDirective>
      </TabComponent>
    </div>
  );
};

export default OperationFilterTabs;
